<template>
  <h1>InputMultipleAnswers</h1>

  <div class="row">
    <input-multiple-answers v-model="current" :choices="choices" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>
  </div>
</template>

<script>
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import InputMultipleAnswers from './InputMultipleAnswers';
import { pickRandom } from '@/utils/arrayUtil';

export default {
  name: 'InputMultipleAnswersDev',
  components: { InputMultipleAnswers },
  extends: DevComponentContainer,
  data() {
    return {
      current: null,
      choices: [
        { value: '1', label: '0' },
        { value: '2', label: '1' },
        { value: '3', label: '2' },
        { value: '4', label: '3' },
        { value: '5', label: '3+' },
      ],
    };
  },
  computed: {
    hasValue() {
      return this.current !== null && this.current.length > 0;
    },
  },
  methods: {
    randomizeValue() {
      const current = [];

      for (const choice of this.choices) {
        if (Math.random() <= 0.5) {
          current.push(choice.value);
        }
      }

      this.current = current;
    },
  },
};
</script>
